/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SegmentsGetThumbnailsQueryResponse, SegmentsGetThumbnailsPathParams, SegmentsGetThumbnailsQueryParams, SegmentsGetThumbnails400, SegmentsGetThumbnails401, SegmentsGetThumbnails403, SegmentsGetThumbnails404 } from "../models/SegmentsGetThumbnails";

export function getSegmentsGetThumbnailsUrl(station: SegmentsGetThumbnailsPathParams["station"]) {
  const res = { method: 'GET', url: `/segments/v1/stations/${station}/thumbnails` as const }
  return res
}

/**
 * @description Returns thumbnail URLs and metadata for video segments that overlap the given time range.
 * @summary List thumbnails for the specified interval
 * {@link /segments/v1/stations/:station/thumbnails}
 */
export async function segmentsGetThumbnails(station: SegmentsGetThumbnailsPathParams["station"], params: SegmentsGetThumbnailsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SegmentsGetThumbnailsQueryResponse, ResponseErrorConfig<SegmentsGetThumbnails400 | SegmentsGetThumbnails401 | SegmentsGetThumbnails403 | SegmentsGetThumbnails404>, unknown>({ method : "GET", url : getSegmentsGetThumbnailsUrl(station).url.toString(), params, ... requestConfig })
  return res.data
}